import TextArea from "../../atoms/forms/TextArea";
import ErrorMessage from "../../atoms/forms/ErrorMessage";
import Label from "../../atoms/forms/Label";

type Props = {
  label: string;
  id: string;
  rows: number;
  defaultValue: string;
  register: any;
  placeHolder: string;
  errorMessage: any;
  labelClasses?: string;
  additionalClasses?: string;
  isDisabled?: boolean;
  descriptionWordCount?: number;
  maxDescriptionWordCount?: number;
};

function TextAreaWithLabel(props: Props) {
  const { id, errorMessage, label, labelClasses = "", descriptionWordCount, maxDescriptionWordCount = "500" } = props;
  return (
    <div className="relative mt-1 rounded-md">
      <Label labelClasses={labelClasses} htmlFor={id} label={label} />
      <TextArea
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
      <ErrorMessage errorMessage={errorMessage} />
      {descriptionWordCount !== undefined && (
        <p
          className="-mt-4 flex justify-end font-satoshi text-xxs 
            font-medium leading-5 text-white text-opacity-70"
        >
          {descriptionWordCount}/{maxDescriptionWordCount}
        </p>
      )}
    </div>
  );
}
export default TextAreaWithLabel;
